export const fmAppMainPages = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  TRANSACTIONS: '/transactions',
  TRANSACTIONS_SETTLED: '/transactions/settled',
  RECURRING_ITEMS: '/transactions/recurring_items',
  TRANSACTIONS_DETAILS: '/transactions/transaction_id/detail',
  PAYMENTS: '/payments',
  PAYMENT_DETAIL: '/payments/:payment_id/detail',
  DIRECT_DEBIT: '/direct_debit',
  SIGN_UP: '/signup',
  PROFILE: '/profile',
  DEV_NOWHERE: '/i_do_not_exist',
} as const;
